// src/App.tsx
import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";

import Home from "pages/Home";
import About from "pages/About";
import Credits from "pages/Credits";

import PlayGame from "pages/PlayGame";
import CreateGame from "pages/game/CreateGame";
import JoinGame from "pages/game/JoinGame";
import Kicked from "pages/Kicked"
import HostDisconnected from "pages/HostDisconnected"
import CreatePlayer from "pages/game/createPlayer/CreatePlayer";
import SelectRole from "pages/game/createPlayer/SelectRole";
import WaitingRoom from "pages/game/WaitingRoom";
import MainGame from "pages/game/main/MainGame";
import HostGameView from "pages/game/main/HostGameView";
import VoteView from "pages/game/main/VoteView";
import SimplifiedGame from "pages/game/simplified/SimplifiedGame";
import VowGame from "pages/game/vow/VowGame";
import VowHost from "pages/game/vow/VowHost";
import VowJoin from "pages/game/vow/VowJoin";
import VowSelectRole from "pages/game/vow/VowSelectRole";
import VowAnalysis from "pages/game/vow/VowAnalysis";
import VowPlay from "pages/VowPlay";

import NotFound from "pages/NotFound";

import DataViewer from "pages/DataViewer";
import LegacyPrototype from "pages/legacy/LegacyPrototype";
import { GameContextProvider } from "GameContext";
import { ChatContextProvider } from "ChatContext";
import { VowGameContextProvider } from "VowGameContext";

const CoreGameProviders: React.FC = () => (
  <GameContextProvider>
    <ChatContextProvider>
      <Outlet />
    </ChatContextProvider>
  </GameContextProvider>
);

const VowGameProviders: React.FC = () => (
  <VowGameContextProvider>
    <Outlet />
  </VowGameContextProvider>
);


const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} /> 
      <Route path="/about" element={<About />} /> 
      <Route path="/credits" element={<Credits />} />
      <Route path="/kicked" element={<Kicked />} />
      <Route path="/disconnect" element={<HostDisconnected />} />
      <Route path="/play" element={<PlayGame />} />
      <Route element={<CoreGameProviders />}>
        <Route path="/play/create" element={<CreateGame />} />
        <Route path="/play/join" element={<JoinGame />} />
        <Route path="/play/join/player" element={<CreatePlayer />} />
        <Route path="/play/join/role" element={<SelectRole />} />
        <Route path="/play/waiting" element={<WaitingRoom />} />
        <Route path="/play/main" element={<MainGame />} />
        <Route path="/play/main/vote" element={<VoteView />} />
        <Route path="/play/main/host" element={<HostGameView />} />
        <Route path="/DataViewer" element={<DataViewer />} />
      </Route>

      <Route element={<VowGameProviders />}>
        <Route path="/vow/play" element={<VowPlay />} />
        <Route path="/vow/select-role" element={<VowSelectRole />} />
        <Route path="/play/simplified" element={<SimplifiedGame />} />
        <Route path="/vow" element={<VowGame />} />
        <Route path="/vow/host" element={<VowHost />} />
        <Route path="/vow/join" element={<VowJoin />} />
        <Route path="/vow/analyze" element={<VowAnalysis />} />
      </Route>
      <Route path="/legacy" element={<LegacyPrototype />} />
      
      {/* Keep this last
        <Route path="*" element={<NotFound />} />
      */}
    </Routes>
  );
};

export default App;
